import React from 'react';
import { Card, Col, Row } from 'react-bootstrap-5';

import OffMarketSummary from './results/off_market_summary';
import OffMarketPropertyImage from './results/off_market_property_image';
import { connect } from 'react-redux';
import { setOffMarketPropertyId } from 'bundles/connect/components/store/actions/off_market_property';
import type { InsightsProperty } from 'bundles/connect/types';

type OffMarketDetailsCardProps = {
  property: InsightsProperty;
  setOffMarketPropertyId: (id: string) => void;
}

function OffMarketDetailsCard({ property, setOffMarketPropertyId }: OffMarketDetailsCardProps) {
  return (
    <Card className="shadow">
      <Row
        className="g-0 align-items-stretch clickable"
        onClick={() => setOffMarketPropertyId(property.propertyId)}
      >
        <Col className="d-flex flex-column">
          <Card.Body className="p-2">
            <OffMarketSummary property={property} />
          </Card.Body>
        </Col>
        <Col className="map-result-thumb off-market-result-thumb d-none d-md-block p-2" md="auto">
          <OffMarketPropertyImage result={property} />
        </Col>
      </Row>
    </Card>
  );
}

export default connect(undefined, { setOffMarketPropertyId })(OffMarketDetailsCard);
